/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import PropTypes from "prop-types";
import Select from "react-select";
import { Col } from "../../../components/simple";

const CompanyOwnerInfo = ({
  onSubmit,
  errors,
  members,
  owner,
  isEdit,
  resetForm
}) => {
  const { control, handleSubmit, setValue } = useForm();
  const ownerSelectRef = useRef(null);

  const handleFormSubmit = data => {
    onSubmit(data);
    resetForm && resetForm();
  };

  useEffect(() => {
    if (owner) {
      const { name, id, email } = owner;
      setValue("owner", name);
      if (ownerSelectRef?.current?.select) {
        ownerSelectRef.current.select.setValue({
          value: id,
          label: name || email
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [owner]);

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="row">
      {isEdit && (
        <Col sm={12} className="d-flex flex-column mb-3">
          <label htmlFor="owner">Owner</label>
          <Controller
            control={control}
            name="owner"
            id="owner"
            render={({ field }) => (
              <Select
                ref={ownerSelectRef}
                placeholder="Owner"
                options={members?.map(item => ({
                  value: item.id,
                  label: item.name || item.email
                }))}
                onChange={val => {
                  field.onChange(val);
                }}
              />
            )}
          />
          {errors.owner && (
            <div className="text-danger">This field is required</div>
          )}
        </Col>
      )}

      <Col sm={12}>
        <input type="submit" className="btn btn-success" />
      </Col>
    </form>
  );
};

CompanyOwnerInfo.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    owner: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      name: PropTypes.string,
      id: PropTypes.string
    })
  ),
  owner: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string
  }),
  isEdit: PropTypes.bool,
  resetForm: PropTypes.func
};

CompanyOwnerInfo.defaultProps = {
  members: [],
  owner: {},
  isEdit: false,
  resetForm: undefined
};

export default CompanyOwnerInfo;
